"use client";

import { Clock, MapPin, Car, ArrowUpRight, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Serviceareas() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const today = new Date().getDay();
  const hours = [{
    day: "Monday",
    time: "8.30am – 4.30pm",
    dayIndex: 1
  }, {
    day: "Tuesday",
    time: "8.30am – 4.30pm",
    dayIndex: 2
  }, {
    day: "Wednesday",
    time: "8.30am – 4.30pm",
    dayIndex: 3
  }, {
    day: "Thursday",
    time: "8.30am – 4.30pm",
    dayIndex: 4
  }, {
    day: "Friday",
    time: "8.30am – 4.30pm",
    dayIndex: 5
  }, {
    day: "Saturday",
    time: "Closed",
    dayIndex: 6
  }, {
    day: "Sunday",
    time: "Closed",
    dayIndex: 0
  }];
  const address = "Merrydown. Kingston Lane, East Preston, BN16 1RP";
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  const mapEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
  return <section data-section-id="906" id="serviceareas" className="bg-background py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">
          {}
          <div ref={leftRef} className={`order-2 lg:order-1 flex flex-col justify-center transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="text-xs font-medium tracking-[0.2em] uppercase text-secondary mb-5 font-default">
              Our Coverage
            </p>
            <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-[48px] leading-[1.1] tracking-tight text-foreground mb-5">
              Serving Sussex & Surrey.
            </h2>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-10 max-w-lg font-default">Coastline Air Conditioning Services provides expert climate control solutions across the region.

Contact us to schedule a site assessment for your property.</p>

            {}
            <div className="pt-6 border-t border-border">
              <p className="text-xs font-medium tracking-[0.2em] uppercase text-secondary mb-3 font-default">OFFICE ADDRESS</p>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary mt-1 shrink-0" strokeWidth={1.5} />
                <div>
                  <p className="text-[17px] text-foreground leading-relaxed font-default">
                    Merrydown. Kingston Lane
                    <br />
                    East Preston, BN16 1RP
                  </p>
                  <Link to={directionsUrl} newTab className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-primary hover:text-primary/80 transition-colors group font-default">
                    Get directions
                    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={1.75} />
                  </Link>
                </div>
              </div>
            </div>

            {}
            <div className="pt-6 mt-6 border-t border-border">
              <div className="flex items-center justify-between mb-4">
                <p className="text-xs font-medium tracking-[0.2em] uppercase text-secondary font-default">
                  Office Hours
                </p>
                <Badge className="bg-primary/10 text-primary border-transparent rounded-lg px-2.5 py-1 text-xs font-medium hover:bg-primary/10 font-default">
                  <span className="inline-block w-1.5 h-1.5 rounded-lg bg-primary mr-1.5" />
                  Open now
                </Badge>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-primary mt-1 shrink-0" strokeWidth={1.5} />
                <ul className="flex-1 space-y-2.5">
                  {hours.map((h, i) => {
                  const isToday = h.dayIndex === today;
                  return <li data-index={i} key={h.day} className={`flex items-center justify-between text-[15px] font-default ${isToday ? "text-foreground font-medium" : "text-muted-foreground"}`}>
                        <span className="flex items-center gap-2">
                          {isToday && <span className="inline-block w-1.5 h-1.5 rounded-lg bg-secondary" />}
                          {h.day}
                        </span>
                        <span className="tabular-nums">{h.time}</span>
                      </li>;
                })}
                </ul>
              </div>
            </div>

            {}
            

            {}
            <div className="mt-10">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-7 h-12 text-base font-medium shadow-md font-default">
                <Link to={directionsUrl} newTab>
                  Get Directions
                  <ArrowRight className="w-4 h-4 ml-1" strokeWidth={2} />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`order-1 lg:order-2 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="relative h-[420px] sm:h-[520px] lg:h-full lg:min-h-[640px] rounded-lg overflow-hidden shadow-lg border border-border">
              <iframe title="Coastline office location" src={mapEmbedUrl} className="absolute inset-0 w-full h-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />

              {}
              <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-full">
                <div className="relative flex flex-col items-center">
                  <div className="relative flex items-center justify-center w-12 h-12 rounded-lg bg-primary shadow-lg ring-4 ring-background">
                    <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="currentColor" aria-hidden="true">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                    </svg>
                  </div>
                  <div className="w-3 h-3 rotate-45 bg-primary -mt-1.5 shadow-md" />
                </div>
              </div>

              {}
              <div className="absolute bottom-5 left-5 right-5 sm:right-auto sm:max-w-xs bg-background/95 backdrop-blur-sm rounded-lg shadow-lg border border-border p-4">
                <p className="font-default font-bold text-lg text-foreground leading-tight mb-1">
                  Coastline HQ
                </p>
                <p className="text-xs text-muted-foreground mb-2.5 leading-relaxed font-default">
                  East Preston, West Sussex
                </p>
                <Link to={mapsUrl} newTab className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:text-primary/80 transition-colors group font-default">
                  View on Maps
                  <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}